<form [formGroup]="form" layout-horizontal layout-align-items-center>
  <rt-select
    [options]="state.yearOptions"
    [hasSearch]="false"
    [hasWhiteBackground]="true"
    [includeEmptyOption]="true"
    [noMaxHeight]="true"
    [placeholder]="'app.common.year' | translate"
    formControlName="year"
    [minDropdownWidth]="80"
    margin-right-small-xx
  />
  <rt-select
    [options]="state.monthOptions"
    [hasSearch]="false"
    [hasWhiteBackground]="true"
    [includeEmptyOption]="true"
    [minDropdownWidth]="'max-content'"
    [noMaxHeight]="true"
    [placeholder]="'app.common.month' | translate"
    formControlName="month"
    margin-right-small-xx
  />
  <rt-select
    [options]="state.dayOptions"
    [hasSearch]="false"
    [hasWhiteBackground]="true"
    [includeEmptyOption]="true"
    [noMaxHeight]="true"
    [minDropdownWidth]="80"
    [placeholder]="'app.common.day' | translate"
    formControlName="day"
    margin-right-small-xx
  />
</form>
